import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaArrowRight, FaCheckCircle } from 'react-icons/fa';

const CallToAction = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const transition = { type: 'spring', duration: 2.5 };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email.trim()) {
      setSubmitted(true);
    }
  };

  return (
    <section className="relative px-4 md:px-12 py-20 text-white overflow-hidden max-w-7xl mx-auto" id="join">
      {/* Background Blurs */}
      <div className="absolute w-96 h-96 bg-red-600/20 blur-[160px] rounded-full top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 -z-10" />

      <div className="max-w-5xl mx-auto bg-gradient-to-r from-[#181a24]/95 via-[#14161f]/95 to-[#181a24]/95 backdrop-blur-2xl p-8 sm:p-14 rounded-3xl border border-white/10 shadow-2xl grid grid-cols-1 lg:grid-cols-2 gap-10 items-center relative overflow-hidden">
        {/* Top accent line */}
        <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-transparent via-red-600 to-transparent" />

        {/* Left Side */}
        <motion.div
          className="flex flex-col gap-6"
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={transition}
          viewport={{ once: true }}
        >
          <span className="bg-red-600/20 text-red-500 border border-red-600/30 px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-widest w-fit shadow-md">
            1-Day Free Pass
          </span>
          <h2 className="text-3xl sm:text-5xl font-black uppercase leading-tight tracking-wide">
            Ready to{' '}
            <span className="text-transparent [-webkit-text-stroke:_1.5px_white]">Transform</span>
            <br />
            Your Body?
          </h2>
          <p className="text-gray-300 text-xs sm:text-sm leading-relaxed">
            Join IDOL FITNESS ZONE today and test our Olympic equipment, coaches, and cardio floor. Over 900+
            members have already started their transformation journey with us across 3 Coimbatore units.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2">
            {[
              'Free 1st-session trial',
              'Personalised workout plan',
              'Access to all 3 gym units',
              'Expert coach support',
            ].map((perk, i) => (
              <motion.div
                key={i}
                className="flex items-center gap-2.5 text-xs text-gray-200"
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ delay: i * 0.1, ...transition }}
                viewport={{ once: true }}
              >
                <FaCheckCircle className="text-red-500 text-sm flex-shrink-0" />
                <span>{perk}</span>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Right Form Side */}
        <motion.div
          className="bg-white/5 backdrop-blur-xl p-8 rounded-3xl border border-white/10 shadow-xl"
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={transition}
          viewport={{ once: true }}
        >
          {!submitted ? (
            <form className="flex flex-col gap-5" onSubmit={handleSubmit}>
              <h3 className="text-xl font-black uppercase text-white">Start Your Fitness Journey</h3>
              <p className="text-xs text-gray-300">Enter your email and our trainers will reach out with your pass.</p>
              
              <div className="flex flex-col gap-2">
                <input
                  type="email"
                  placeholder="Your email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="bg-white/10 border border-white/20 rounded-xl px-4 py-3.5 text-white placeholder-gray-400 focus:outline-none focus:border-red-500 transition-colors text-xs"
                />
              </div>

              <div className="flex flex-col gap-3">
                <button
                  type="submit"
                  className="w-full bg-gradient-to-r from-red-600 to-red-700 hover:from-red-500 hover:to-red-600 text-white font-black py-4 rounded-xl transition-all shadow-lg shadow-red-600/30 flex items-center justify-center gap-3 text-xs uppercase tracking-wider cursor-pointer group"
                >
                  <span>Start Your Fitness Journey</span>
                  <FaArrowRight className="group-hover:translate-x-1 transition-transform" />
                </button>

                <a
                  href="https://wa.me/917339504861?text=Hi%20Idol%20Fitness%20Zone,%20I%20would%20like%20to%20book%20a%20fitness%20consultation!"
                  target="_blank"
                  rel="noreferrer"
                  className="w-full bg-white/5 hover:bg-white/15 text-gray-300 hover:text-white border border-white/15 font-bold py-3 rounded-xl transition-all flex items-center justify-center text-xs uppercase tracking-wider"
                >
                  Book a Fitness Consultation
                </a>
              </div>

              <p className="text-[10px] text-gray-400 text-center">🔒 100% Privacy. No spam ever.</p>
            </form>
          ) : (
            <motion.div
              className="flex flex-col items-center text-center py-6 gap-3"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5 }}
            >
              <div className="text-5xl">🎉</div>
              <h3 className="text-xl font-black uppercase text-white">You're On The List!</h3>
              <p className="text-xs text-gray-300 leading-relaxed">
                Thanks for joining! Our team will reach out to <strong className="text-red-400">{email}</strong> within 24
                hours to schedule your free trial session.
              </p>
            </motion.div>
          )}
        </motion.div>
      </div>
    </section>
  );
};

export default CallToAction;

